import { buttonVariants } from 'design-system'

export const VisitWebsiteButton = () => (
  <a
    href="https://yellowdig.co/"
    className={`${buttonVariants({ buttonType: 'link' })} rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300`}
    target="_blank"
    rel="noopener noreferrer">
    Visit Website
  </a>
)
